// Extend namespace by creating a new object
pyzel.menuMobile = {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.menuMobile.init = function() {

	// Show the menu
	$('.js-menu-mobile-toggle').on('click', function(){
		pyzel.menuMobile.toggle();
	});

};



/**
 * Show or hide the menu
 *
 * @return void
 */
pyzel.menuMobile.toggle = function() {

	var menu = $('.js-menu-mobile');

	if ( menu.is(':visible') ) {
		$('.js-submenu').hide();
		menu.hide();
		$('.js-menu-mobile-toggle').removeClass('open');
	} else {
		menu.show();
		$('.js-menu-mobile-toggle').addClass('open');
	}

};